exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".star-score[data-v-5c8a722f] {\n  display: flex;\n}\n.star-score[data-v-5c8a722f]  svg {\n  margin-right: 4px;\n}\n.star-score[data-v-5c8a722f]  svg:last-child {\n  margin-right: 0px;\n}\n.star-score span.clickable[data-v-5c8a722f] {\n  cursor: pointer;\n}\n.star-score.large[data-v-5c8a722f]  svg {\n  width: 24px;\n  height: 24px;\n  margin-right: 6px;\n}", ""]);

// exports
